import { Typography } from '@mui/material';
import { PAGINATION_RESULTS_LABEL } from '@/constants/constants';

type TableCountsProps = {
  currentPage: number;
  pageSize: number;
  totalCount: number;
  tableKey: string;
};

const TableCounts = ({ currentPage, pageSize, totalCount, tableKey }: TableCountsProps) => {
  const startingRecordNumber = currentPage === 1 ? 1 : (currentPage - 1) * pageSize + 1;
  const lastRecordNumber = Math.min(currentPage * pageSize, totalCount);
  const resultLabel = PAGINATION_RESULTS_LABEL?.[tableKey] || 'results';

  return (
    <Typography>
      Displaying {startingRecordNumber} - {lastRecordNumber} of {totalCount.toLocaleString()} {resultLabel}
    </Typography>
  );
};

export default TableCounts;
